export const employmentStatuses = [
  { id: 'FULL_TIME', name: 'Full Time' },
  { id: 'PART_TIME', name: 'Part Time' },
  { id: 'CASUAL', name: 'Casual' },
];
